import React, { useEffect, useRef } from 'react';
import { exportJPG } from '../../services/export';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

function MessageChart({ id, json }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = document.getElementById(`${id}`);
    var chartConf = JSON.parse(json);

    // Check if there's an existing chart, destroy it before creating a new one
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new Chart(ctx, chartConf);

    return () => {
      // Clean up the chart when the component unmounts
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [id, json]);

  const handleClick = () => {
    exportJPG(id);
  };

  return (
    <>
      <div className="controls-container">
        <button className="download-button" type="chart" onClick={() => handleClick()}>
          jpg
        </button>
      </div>
      <div className="chart-container" id="my-chart-test">
        <canvas id={id}></canvas>
      </div>
    </>
  );
}

export default MessageChart;
